import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Container, Card, Button, Spinner, Alert, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// ★★★ Tiptap関連ライブラリのインポート（最終修正版） ★★★
import { useEditor, EditorContent } from '@tiptap/react';
// StarterKitの代わりに、必要な機能を個別にインポート
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Heading from '@tiptap/extension-heading';
import Underline from '@tiptap/extension-underline';
// TextStyleとColorをそれぞれの正しいパッケージからインポート
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';

// Tiptap用のCSSをインポート
import './Tiptap.css';

// Tiptapのツールバー部分をコンポーネントとして定義
const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="border rounded-top p-2 bg-light">
      <ButtonGroup className="me-2">
        <Button variant="outline-secondary" size="sm" onClick={() => editor.chain().focus().toggleBold().run()} className={editor.isActive('bold') ? 'is-active' : ''}>太字</Button>
        <Button variant="outline-secondary" size="sm" onClick={() => editor.chain().focus().toggleItalic().run()} className={editor.isActive('italic') ? 'is-active' : ''}>斜体</Button>
        <Button variant="outline-secondary" size="sm" onClick={() => editor.chain().focus().toggleUnderline().run()} className={editor.isActive('underline') ? 'is-active' : ''}>下線</Button>
      </ButtonGroup>
      <ButtonGroup className="me-2">
         <Button variant="outline-secondary" size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()} className={editor.isActive('heading', { level: 4 }) ? 'is-active' : ''}>見出し</Button>
         <Button variant="outline-secondary" size="sm" onClick={() => editor.chain().focus().setParagraph().run()} className={editor.isActive('paragraph') ? 'is-active' : ''}>本文</Button>
      </ButtonGroup>
       <ButtonGroup className="me-2 align-items-center">
        <span className="ms-2 me-1 small">文字色:</span>
        <input type="color" className="form-control-color" onChange={event => editor.chain().focus().setColor(event.target.value).run()} value={editor.getAttributes('textStyle').color || '#000000'} />
      </ButtonGroup>
    </div>
  );
};


function DeliveryEstimateAdmin() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const contentDocRef = doc(db, 'system_settings', 'delivery_info');

  const editor = useEditor({
    // ★★★ エディタの拡張機能を個別に指定 ★★★
    extensions: [
      Document,
      Paragraph,
      Text,
      Bold,
      Italic,
      Heading.configure({
        levels: [4], // ツールバーで使用する見出しレベルを指定
      }),
      Underline,
      TextStyle, // TextStyleを登録
      Color,     // Colorを登録
    ],
    content: '', // 初期コンテンツは読み込み時に設定
  });

  useEffect(() => {
    document.title = '納期目安の管理 | My Order System';
    
    if (!editor) {
      return;
    }

    setLoading(true);
    getDoc(contentDocRef).then(docSnap => {
      const dbContent = docSnap.exists() ? docSnap.data().content : 'ここに内容を入力してください。';
      if (editor.isDestroyed) return;
      // 'false'を指定することで、このsetContentがonUpdateイベントを再度トリガーするのを防ぐ
      editor.commands.setContent(dbContent, false); 
    }).catch(err => {
      setError('データの読み込みに失敗しました。');
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });

  }, [editor]);

  const handleSave = async () => {
    if (!editor) return;
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      await setDoc(contentDocRef, { content: editor.getHTML() });
      setSuccess('納期目安を保存しました。');
    } catch (err) {
      setError('保存に失敗しました。');
      console.error(err);
    }
    setSaving(false);
  };

  if (!editor) {
    return <Container className="d-flex justify-content-center align-items-center vh-100"><Spinner /></Container>;
  }

  return (
    <main>
      <Container className="my-4">
        <Card className="shadow-sm">
          <Card.Header as="h2" className="p-3">納期目安の管理</Card.Header>
          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            <p className="text-muted">
              下のボックス内で内容を編集してください。太字、文字色、下線などの装飾が可能です。
            </p>

            <MenuBar editor={editor} />
            <EditorContent editor={editor} className="border-start border-end border-bottom rounded-bottom p-3" style={{ minHeight: '300px' }} />

            <div className="d-grid mt-4">
              <Button onClick={handleSave} disabled={saving || loading} size="lg">
                {saving ? <Spinner as="span" size="sm" /> : 'この内容で保存する'}
              </Button>
            </div>
            <hr className="my-4" />
            <Link to="/admin">管理者メニューに戻る</Link>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}

export default DeliveryEstimateAdmin;

